class APIS {
	apis() {
		return {
			getCountries: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/fetch/countries'
			},
			submitForm: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/register'
			},
			submitRegistrationForm: {
				headers: {
					'xt-client-token': null
				},
				method: 'post',
				path: '/backend/client/onboarding'
			},
			submitImage: {
				headers: {
					'xt-client-token': null
				},
				method: 'post',
				path: '/registration/upload'
			},
			updateProfile: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/client/update'
			},
			updateSubjectID: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/client/update/subject'
			},
			getSubjectID: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/backend/fetch/subject/:client_id'
			},
			getClientSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/allsettings'
			},
			updateClientSetting: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/allsettings'
			},
			generateID: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/configure/webhook'
			},
			fetchConfigureWebHook: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get/webhook'
			},
			healthCheck: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/health/check'
			},
			migrateTemplate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/migration'
			},
			getCallSettings: {
				headers: {
					'xt-user-token': null,
				},
				method: 'post',
				path: '/get/call/setting'
			},
			updateCallSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call/setting'
			},
			getMetaCallingSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get-calling-settings/meta'
			},
			updateMetaCallingSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update-calling-settings/meta'
			},
			updateCallRecordingSettings: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/client/call-recording-settings'
			},
			registrationFlowCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-registration-config/create'
			},
			registrationFlowFetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-registration-config/fetch'
			},
			registrationFlowFetchAllClients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-registration-config/list'
			},
			registrationFlowUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-registration-config/update'
			},
			registrationFlowDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client-registration-config/delete'
			},
		};
	}
}

export default new APIS();
